import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPaymentLinksURL } from 'growth-payments-core/urls/urls';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import ModalWrapper from '../ModalWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentLinksModal = props => {
  const {
    handleInterstitialModalClose,
    screen
  } = props;
  const Body = /*#__PURE__*/_jsx(Text, {
    as: "p",
    textAlign: "start",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.paymentLinksModal.embedAPaymentLink",
      options: {
        location: screen.toLowerCase()
      }
    })
  });
  const Footer = /*#__PURE__*/_jsx(Button, {
    use: "primary",
    external: true,
    href: getPaymentLinksURL(),
    block: true,
    onClick: () => track(events.paymentsInterstitialModalInteraction, {
      action: 'click',
      screen,
      value: 'goToPaymentLinks'
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.paymentLinksModal.goToPaymentLinks"
    })
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: handleInterstitialModalClose,
    modalName: "paymentLinksModal",
    Body: Body,
    Footer: Footer,
    illustrationName: "payments",
    illustrationWidth: "200px",
    padding: "1000"
  });
};
export default PaymentLinksModal;